import React, { Component, PropTypes } from 'react';
import { withRouter, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { clearGiftCardsErrors, setGiftCard, newGiftcards } from '../actions';
import { cyan900, cyan500 } from 'material-ui/styles/colors';
import Alert from '../components/home/Alert';
import Checkbox from 'material-ui/Checkbox';
import FontIcon from 'material-ui/FontIcon';
import { CSVLink } from 'react-csv';
import _ from 'lodash';

const propTypes = {
    dispatch: PropTypes.func,
    isAuthenticated: PropTypes.bool,
    error: PropTypes.any,
    salesChannels: PropTypes.any,
    discounts: PropTypes.array,
    query: PropTypes.object.isRequired,
};

class GiftCardNewPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            auth: !props.isAuthenticated,
            alertOpen: false,
            alertMessage: '',
            error: false,
            required: {
                giftCodePrefix: null,
                amount: null,
            },
            giftcard: {
                giftCodePrefix: 'OTV',
                amount: 50,
                quantity: 10,
                giftCodeLength: 4,
                active: true
            },
        };
        autoBind(this);
    }
    getChildContext() {
        return { muiTheme: getMuiTheme(baseTheme) };
    }
    componentWillMount() {
        if (!this.props.isAuthenticated) {
            browserHistory.goBack();
        }
        this.setRequiredParams();
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.error) {
            this.setState({
                alertOpen: true,
                error: true,
                alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
            });
        }
        // if (nextProps.giftcard && !nextProps.error) {
        //     this.setState({
        //         alertOpen: true,
        //         error: false,
        //         alertMessage: 'Gift Card saved successfully!',
        //     });
        // }
         this.setRequiredParams();
    }
    setRequiredParams() {
        const required = this.state.required;
        const giftcard = this.state.giftcard;
        Object.keys(this.state.required).forEach((paramName) => {
            const param = giftcard[paramName];
            required[paramName] = (param == null || param.length === 0 || param === 0) ? 'This field is required' : null;
        });
        this.setState({ required });
    }
    handleChange(e) {
        const nextState = this.state.giftcard;
        if (e.target.type === 'checkbox') {
            _.set(nextState, e.target.name, e.target.checked);
        } else {
            _.set(nextState, e.target.name, e.target.value);
        }
        this.setState({
            giftcard: nextState,
        });
        this.setRequiredParams();
    }

    handleSubmit() {
        return this.props.dispatch(newGiftcards(this.state.giftcard));
      }
    handleCancel() {
        this.props.dispatch(clearGiftCardsErrors());
        browserHistory.push('/giftcards?page=1');
    }
    alertHandleClose() {
        this.setState({
            alertMessage: '',
            alertOpen: false,
        });
        if (!this.state.error) {
            browserHistory.push('/giftcards?page=1');
        }
    }
    renderDownload() {
        if (this.props && this.props.giftcard && this.props.giftcard.length) {
          const iconStyles = {
            marginRight: 14,
          };
          return (
            <div>
              <FontIcon className="fa fa-download" style={iconStyles} />
              <CSVLink data={this.props.giftcard} >Download GiftCard(s)</CSVLink>
            </div>
          )
        } else {
          return null;
        }
      }
    render() {
        const authPage = {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
        };
        const styles = {
            floatingLabelStyle: {
                color: cyan900,
            },
            inputStyle: {
                marginRight: '2%',
                width: '250px',
            },
            datePickerStyle: {
                marginRight: '2%',
                width: '250px',
                float: 'left',
            },
        };
        return (
            <div className="sales-channels component" style={authPage}>
                <h2>New Gift Card</h2>
                <Alert
                    alertOpen={this.state.alertOpen}
                    alertHandleClose={() => this.alertHandleClose()}
                    alertMessage={this.state.alertMessage}
                />
                <div className="content">
                    <div className="float-right">
                        <RaisedButton
                            label="Cancel"
                            style={{ margin: '20px' }}
                            primary
                            onClick={this.handleCancel}
                        />
                        <RaisedButton
                            label="Save"
                            primary
                            onClick={this.handleSubmit}
                        />
                    </div>
                    <TextField
                        floatingLabelText="Gift Code Prefix"
                        floatingLabelStyle={styles.floatingLabelStyle}
                        value={this.state.giftcard.giftCodePrefix || ''}
                        name="giftCodePrefix"
                        onChange={this.handleChange}
                        style={styles.inputStyle}
                        errorText={this.state.required.giftCodePrefix}
                        errorStyle={{ color: cyan500 }}
                    />
                    <TextField
                        floatingLabelText="Gift Code Length"
                        floatingLabelStyle={styles.floatingLabelStyle}
                        value={this.state.giftcard.giftCodeLength || ''}
                        name="giftCodeLength"
                        onChange={this.handleChange}
                        style={styles.inputStyle}
                    />
                    <br />
                    <TextField
                        floatingLabelText="Amount"
                        floatingLabelStyle={styles.floatingLabelStyle}
                        value={this.state.giftcard.amount || ''}
                        name="amount"
                        onChange={this.handleChange}
                        style={styles.inputStyle}
                        errorText={this.state.required.amount}
                        errorStyle={{ color: cyan500 }}
                    />
                    <TextField
                        floatingLabelText="Quantity"
                        floatingLabelStyle={styles.floatingLabelStyle}
                        value={this.state.giftcard.quantity || ''}
                        name="quantity"
                        onChange={this.handleChange}
                        style={styles.inputStyle}
                    />
                    <br />
                    <br />
                    <Checkbox
                        label="Active"
                        defaultChecked={this.state.giftcard.active}
                        name="active"
                        onCheck={this.handleChange}
                    />
                    <br />
                    {this.renderDownload()}
                </div>
            </div>
        );
    }
}

GiftCardNewPage.childContextTypes = {
    muiTheme: PropTypes.object.isRequired,
};

GiftCardNewPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
    return {
        isAuthenticated: state.auth.isAuthenticated,
        error: state.promotions.error,
        promotion: state.promotions.promotion,
        giftcards: state.giftCards,
        giftcard: state.giftCards.giftcard,
        discounts: state.discounts.results,
        salesChannels: state.salesChannels.results,
        query: ownProps.location.query,
    };
}

export default withRouter(connect(mapStateToProps)(GiftCardNewPage));



// WEBPACK FOOTER //
// ./src/containers/GiftCardNewPage.js